import { useRef, useState } from "react";
import { uploadImage, resolveAsset } from "../../lib/api";
import { toast } from "sonner";
import { Upload, Trash2, Loader2 } from "lucide-react";

export const inputCls =
  "w-full rounded-lg border border-neutral-300 bg-white px-3 py-2 text-sm text-[#101828] focus:outline-none focus:ring-2 focus:ring-[#0057FF]/40";

export const Field = ({ label, value, onChange, type = "text", testId, placeholder }) => (
  <label className="block">
    <span className="text-xs font-medium uppercase tracking-wide text-neutral-500">{label}</span>
    <input
      type={type}
      data-testid={testId}
      className={`${inputCls} mt-1`}
      value={value ?? ""}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
    />
  </label>
);

export const Area = ({ label, value, onChange, rows = 8, testId }) => (
  <label className="block">
    <span className="text-xs font-medium uppercase tracking-wide text-neutral-500">{label}</span>
    <textarea
      data-testid={testId}
      rows={rows}
      className={`${inputCls} mt-1`}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
    />
  </label>
);

export const ImagePicker = ({ label, value, onChange, testId, allowRemove = false }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const url = await uploadImage(f);
      onChange(url);
      toast.success("Imagen subida");
    } catch {
      toast.error("Error al subir la imagen");
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  return (
    <div>
      <span className="text-xs font-medium uppercase tracking-wide text-neutral-500">{label}</span>
      <div className="mt-2 flex items-center gap-3 flex-wrap">
        {value ? (
          <img src={resolveAsset(value)} alt={label} className="h-20 w-20 object-cover rounded-lg border border-neutral-200" />
        ) : (
          <div className="h-20 w-20 rounded-lg border-2 border-dashed border-neutral-300 flex items-center justify-center text-neutral-400 text-xs text-center px-1">
            Sin imagen
          </div>
        )}
        <button
          type="button"
          data-testid={testId}
          disabled={busy}
          onClick={() => ref.current?.click()}
          className="inline-flex items-center gap-2 rounded-full bg-[#0057FF] text-white text-sm px-4 py-2 disabled:opacity-60"
        >
          {busy ? <Loader2 size={15} className="animate-spin" /> : <Upload size={15} />}
          {value ? "Reemplazar" : "Subir"}
        </button>
        {allowRemove && value && (
          <button
            type="button"
            data-testid={testId ? `${testId}-remove` : undefined}
            onClick={() => onChange(null)}
            className="inline-flex items-center gap-2 rounded-full border border-red-300 text-red-600 text-sm px-4 py-2"
          >
            <Trash2 size={15} /> Quitar
          </button>
        )}
        <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} />
      </div>
    </div>
  );
};
